export enum ImageErrorType {
  FileTypeNotAllowedError = 'fileTypeNotAllowedError',
  FileTooLarge = 'fileTooLarge'
}
